import React from "react";

import { FormHelperText, MenuItem, Select } from "@mui/material";
import { useController } from "react-hook-form";

import { ReactComponent as ArrowDown } from "../../../Assets/Images/ArrowDown.svg";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import Label from "./Label";

export const RemoteSelect = ({
  control,
  label,
  name,
  menuItemLabel,
  menuItemKey,
  options,
  size,
  fullWidth,
  required,
  placeholder,
  height,
  fontSize,
  disabled,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });

  return (
    <FormItemsWrap>
      <Label label={label} required={required} />
      <Select
        fullWidth={fullWidth}
        IconComponent={ArrowDown}
        variant="outlined"
        size={size ?? "small"}
        displayEmpty
        error={fieldState?.invalid}
        disabled={disabled}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
          height: height || null,
          fontSize: fontSize || "13px",
          ".MuiSelect-icon": {
            marginRight: "10px",
          },
        }}
        placeholder={placeholder}
        {...field}
      >
        <MenuItem skey={Math.random() * 10} value="" disabled>
          <span
            style={{
              fontSize: fontSize || "13px",
              color: "#8E8E93",
            }}
          >
            {placeholder}
          </span>
        </MenuItem>

        {options &&
          options?.length &&
          options?.length > 0 &&
          options.map((item, index) => (
            <MenuItem
              key={index}
              value={item[menuItemKey]}
              style={{ fontSize: fontSize || "13px", color: "#37373A" }}
            >
              {item[menuItemLabel]}
            </MenuItem>
          ))}
      </Select>
      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};
